import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminLeadDetail from "@/pages/admin/AdminLeadDetail";

export const Route = createFileRoute("/admin/leads/$kind/$id")({
  head: () => pageHead("Admin \u2014 Leads \u2014 Kind \u2014 Id \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminLeadDetail,
});
